import React, { useEffect, useMemo, useState } from "react";
import "react-medium-image-zoom/dist/styles.css";
import {
  BlockTitle,
  Col,
  Row,
  RSelect
} from "../../components/Component";

import { ErrorMessage } from "@hookform/error-message";
import {
  Controller,
  useFormContext,
  useWatch,
} from "react-hook-form";
import { NumericFormat } from "react-number-format";
import { GET } from "../../helper/api";
import {
  BILL_STATUS,
  EXTERNAL_PORT_FEE_CATEGORY_ID,
} from "../../utils/Utils";

const BILL_STATUS_OPTIONS = Object.keys(BILL_STATUS).map((c) => ({
  label: BILL_STATUS[c],
  value: c,
}));

const BillExternalPortFeeCreateForm = ({
  id,
  duplicateId,
  billData,
  externalContractOptions = [],
  disabledForm = false,
  setLoading = () => { },
}) => {
  const { errors, register, control, setValue } = useFormContext();
  const [ingredientOptions, setIngredientOptions] = useState([]);
  const [deliveryProviderOptions, setDeliveryProviderOptions] = useState([]);

  const status = useWatch({
    control,
    name: "status",
  });


  useEffect(() => {


    GET("customer", {}, true).then((resp) => {
      const { data } = resp;
      if (data) {
        setDeliveryProviderOptions(
          data.map(c => ({
            label: c.name,
            value: c.id,
            data: c,
          }))
        )
      } else {
        setDeliveryProviderOptions([]);
      }
    });
  }, []);

  const externalContractIncludeSellectedOptions = useMemo(() => {
    const temp = [...externalContractOptions];
    if (billData?.billExternalContract && !temp.map(e => e.value).includes(billData.billExternalContractId)) {
      temp.push({
        label: billData.billExternalContract.name,
        value: billData.billExternalContract.id,
        data: billData.billExternalContract,
      })
    }
    return temp
  }, [externalContractOptions, billData])

  useEffect(() => {
    GET("ingredient", {}, true).then((resp) => {
      const { data } = resp;
      if (data && data.rows && data.rows.length) {
        setIngredientOptions(
          data.rows.filter(c => !!EXTERNAL_PORT_FEE_CATEGORY_ID[c.id]).map((c) => ({
            label: c.name,
            value: c.id,
            data: c,
          }))
        );
      }
    });


  }, []);


  return (
    <form className="position-relative">
      {disabledForm ? <div className="form-overlay"></div> : <></>}

      <div className="mb-4">
        <Row className="g-2">
          <Col size={12}>
            <BlockTitle tag="h5">Thông tin khách hàng</BlockTitle>
          </Col>
          <Col md="6">
            <div className="form-group">
              <label className="form-label" >
                Khách hàng <span className="text-danger">*</span>
              </label>
              <div className="form-control-wrap">
                <Controller
                  control={control}
                  name="customerId"
                  rules={{
                    required: "Vui lòng nhập thông tin",
                  }}
                  render={({ onChange, value, name, ref }) => (
                    <RSelect
                      ref={ref}
                      name={name}
                      options={deliveryProviderOptions}
                      value={
                        deliveryProviderOptions.find((c) => c.value === value) || null
                      }
                      onChange={(val) => {
                        onChange(val.value);
                        setValue('billExternalContractId', null)
                      }}
                    />
                  )}
                />
                <ErrorMessage
                  errors={errors}
                  name="customerId"
                  render={({ message }) => (
                    <span className="invalid">{message}</span>
                  )}
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>

      <Row className="mt-3 g-2">
        <Col size={12}>
          <BlockTitle tag="h5">Thông tin đơn hàng</BlockTitle>
        </Col>
        <Col md="6">
          <div className="form-group">
            <label className="form-label" htmlFor="customer">
              Mã đơn hàng <span className="text-danger">*</span>
            </label>
            <div className="form-control-wrap">
              <input
                type="text"
                className="form-control"
                name="id"
                ref={register({
                  required: "Vui lòng nhập thông tin",
                })}
                disabled={!!id && !duplicateId}
              />
              <ErrorMessage
                errors={errors}
                name="id"
                render={({ message }) => (
                  <span className="invalid">{message}</span>
                )}
              />
            </div>
          </div>
        </Col>



        <Col md="6">
          <div className="form-group">
            <label className="form-label" >
              Nguyên liệu<span className="text-danger">*</span>
            </label>
            <div className="form-control-wrap">
              <Controller
                control={control}
                name="ingredientId"
                rules={{ required: "Vui lòng nhập thông tin" }}
                render={({ onChange, value, name, ref }) => (
                  <RSelect
                    ref={ref}
                    name={name}
                    options={ingredientOptions}
                    value={
                      ingredientOptions.find((c) => c.value === value) || null
                    }
                    onChange={(val) => onChange(val.value)}
                  />
                )}
              />
              <ErrorMessage
                errors={errors}
                name="ingredientId"
                render={({ message }) => (
                  <span className="invalid">{message}</span>
                )}
              />
            </div>
          </div>
        </Col>




        <Col md={6}>
          <div className="form-group">
            <label className="form-label" >
              Giá VNĐ<span className="text-danger">*</span>
            </label>
            <div className="form-control-wrap">
              <Controller
                control={control}
                name="unitPrice"
                rules={{ required: "Vui lòng nhập thông tin" }}
                render={({ onChange, value, ref }) => (
                  <NumericFormat
                    className="form-control"
                    getInputRef={ref}
                    type="text"
                    value={value}
                    thousandsGroupStyle="thousand"
                    thousandSeparator=","
                    decimalScale={2}
                    onValueChange={(val) => onChange(val.floatValue)}
                  />
                )}
              />
              <ErrorMessage
                errors={errors}
                name="unitPrice"
                render={({ message }) => (
                  <span className="invalid">{message}</span>
                )}
              />
            </div>
          </div>
        </Col>

        <Col md="6">
          <div className="form-group">
            <label className="form-label" >
              Hợp đồng xuất khẩu{` `}<span className="text-danger">*</span>
            </label>
            <div className="form-control-wrap">
              <Controller
                control={control}
                name="billExternalContractId"
                rules={{ required: "Vui lòng nhập thông tin" }}
                render={({ onChange, value, name, ref }) => (
                  <RSelect
                    isClearable
                    ref={ref}
                    name={name}
                    options={externalContractIncludeSellectedOptions
                    }
                    value={
                      externalContractIncludeSellectedOptions.find(
                        (c) => c.value === value
                      ) || null
                    }
                    onChange={(val) => {
                      onChange(val?.value || "");
                    }}
                  />
                )}
              />
              <ErrorMessage
                errors={errors}
                name="billExternalContractId"
                render={({ message }) => (
                  <span className="invalid">{message}</span>
                )}
              />
            </div>
          </div>
        </Col>
        <Col md="6">
          <div className="form-group">
            <label className="form-label" >
              Thời gian tạo đơn<span className="text-danger">*</span>
            </label>
            <div className="form-control-wrap">
              <input
                rows={3}
                className="form-control"
                type="datetime-local"
                name="createdAt"
                ref={register({ required: "Vui lòng nhập thông tin" })}
              />
              <ErrorMessage
                errors={errors}
                name="createdAt"
                render={({ message }) => (
                  <span className="invalid">{message}</span>
                )}
              />
            </div>
          </div>
        </Col>
        <Col size="12">
          <div className="form-group">
            <label className="form-label" >
              Ghi chú
            </label>
            <div className="form-control-wrap">
              <textarea
                rows={3}
                className="form-control"
                style={{ height: "unset" }}
                name="note"
                ref={register()}
              />
            </div>
          </div>
        </Col>
      </Row>
      <div className="mt-4">
        <Row className="mt-4">
          <Col size="12" md={3}>
            <div className="form-group">
              <label className="form-label" >
                Trạng thái đơn<span className="text-danger">*</span>
              </label>
              <div className="form-control-wrap">
                <Controller
                  control={control}
                  name="status"
                  rules={{
                    required: "Vui lòng nhập thông tin",
                  }}
                  render={({ onChange, value, name, ref }) => (
                    <RSelect
                      ref={ref}
                      name={name}
                      options={BILL_STATUS_OPTIONS}
                      value={
                        BILL_STATUS_OPTIONS.find((c) => c.value === value) ||
                        null
                      }
                      onChange={(val) => onChange(val.value)}
                    />
                  )}
                />
                <ErrorMessage
                  errors={errors}
                  name="status"
                  render={({ message }) => (
                    <span className="invalid">{message}</span>
                  )}
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </form>
  );
};

export default BillExternalPortFeeCreateForm;
